var map = {
	"./abdominal.png": "3574",
	"./axilar.png": "b8f3",
	"./biceps.png": "06a9",
	"./coxa-media.png": "ce35",
	"./empty.png": "a4eb",
	"./panturrilha.png": "b3f7",
	"./peitoral.png": "94ed",
	"./subescapular.png": "b31e",
	"./supra-iliaca.png": "71fe",
	"./supraespinhal.png": "2d5d",
	"./triceps.png": "ebb8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a24c";